import {
  Button,
  Checkbox,
  Col,
  Form,
  InputNumber,
  Modal,
  Popover,
  Row,
  Space,
  Spin,
  Table,
  Typography,
} from "antd";
import {
  ColumnPopoverDisplay,
  ExpandSearch,
  InputFields,
  ListActionButton,
  ModalCustom,
} from "components/common";
import React, { useEffect, useRef, useState } from "react";
import { dataTTAP } from "./config";
import Icons from "assets/icons";
import {
  catalogService,
  discountsService,
  medicalExaminationService,
  servicePackage,
  technicalService,
} from "api";
import "./DiscountsAdd.scss";
import { ReactComponent as RecycleIconSVG } from "assets/images/svg/recycle.svg";
import Notification from "components/common/notification/notification";
import { ExcelSVG } from "assets";
import Icon from "assets/icons";
import { ColumnProps } from "types/models";
//import FormAdd from "./FormAdd/FormAdd";
import { Select } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import {
  formatToCurrencyType,
  formatDateToStringTimezone_7,
  formatDateToString,
} from "helper/common";
import { FIELD_TYPE, FORMAT_TIME, tabKeys } from "types/enums";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { setIdKM, setKM } from "redux/reducer/employee";
import dayjs from "dayjs";
import { setActiveKey } from "redux/reducer/common";
import { RangePickerProps } from "antd/es/date-picker";
const {
  INPUT,
  DATE,
  SELECT,
  AUTO_COMPLETE,
  CURRENCY,
  DATE_ON,
  NUMBER,
  CHECKBOX,
  RADIO,
  NORMAL_CHECKBOX,
  NORMAL_CHECKBOX_NONE,
  COMBO_BOX,
  TEXT_AREA,
} = FIELD_TYPE;
const DiscountsAdd = () => {
  const employeesStore = useAppSelector((state) => state.employeesReducer.cckm);
  const employeeMode = useAppSelector(
    (state) => state.employeesReducer.cckmMode
  );
  const [loading, setLoading] = useState<boolean>(false);
  const [form] = Form.useForm();
  const cssProps = {
    labelCol: { xs: 8, sm: 8, md: 8, lg: 12, xl: 12 },
    wrapperCol: { xs: 16, sm: 16, md: 12, lg: 12, xl: 12 },
    css: { xs: 24, sm: 24, md: 24, lg: 12, xl: 12 },
  };
  const [isEditing, setIsEditing] = useState(false);
  const onChange = async (e) => {
    try {
      const isChecked = e.target.checked;

      if (isChecked) {
        const updatedFieldsCV = fieldsTTC.map((field) => {
          if (field.name === "soLanApDung") {
            form.setFieldValue("soLanApDung", "");
            return {
              ...field,
              disable: true,
            };
          } else if (field.name === "soLuotApDungConLai") {
            return {
              ...field,
              disable: true,
            };
          } else {
            return {
              ...field,
              disable: false,
            };
          }
        });
        setFieldsTTC(updatedFieldsCV);
      } else {
        const updatedFieldsCV = fieldsTTC.map((field) => {
          if (field.name === "soLuotApDungConLai") {
            return {
              ...field,
              disable: true,
            };
          } else {
            return {
              ...field,
              disable: false,
            };
          }
        });
        setFieldsTTC(updatedFieldsCV);
      }
    } catch (error) {
      Notification("error", "Đã xảy ra lỗi");
    }
  };

  const dataTTC = [
    {
      type: INPUT,
      name: "tenChuongTrinh",
      label: "Tên chương trình",
      ...cssProps,
      rules: [
        { required: true, message: "Tên chương trình là bắt buộc!" },
        {
          max: 200,
          message: "Định dạng mã chương trình không đúng",
        },
      ],
    },
    {
      type: INPUT,
      name: "maChuongTrinh",
      label: "Mã chương trình",
      ...cssProps,
      rules: [
        { required: true, message: "Đầu mã là bắt buộc!" },
        {
          max: 10,
          message: "Định dạng mã thẻ không đúng",
        },
      ],
    },
    {
      type: NUMBER,
      name: "soLanApDung",
      label: "Số lượng áp dụng",
      ...cssProps,
      // rules: [
      //   { required: true, message: "Số lượng áp dụng là bắt buộc!" },
      //   // {
      //   //   pattern: /^[0-9]*$/, // Quy tắc để chỉ cho phép nhập số
      //   //   message: "Chỉ cho phép nhập số",
      //   // },
      //   // {
      //   //   max: 10,
      //   //   min:0,
      //   //   message: "Số lượng không vượt quá 10 số",
      //   // },
      // ],
      disable: true,
    },
    {
      name: "isKhongGioiHan",
      type: NORMAL_CHECKBOX_NONE,
      label: "Không giới hạn",
      onChange: onChange,
      valuePropName: "checked",
      ...cssProps,
      // checkbox: [
      //   {
      //     label: "Không giới hạn",
      //     value: 1,
      //     span: 32,
      //   },
      // ],
    },
    {
      type: NUMBER,
      name: "soLuotApDungConLai",
      label: "Số lượng áp dụng còn lại",
      ...cssProps,
      disable: true,
    },
    {
      type: TEXT_AREA,
      name: "moTa",
      label: "Mô tả",
      rules: [
        // {
        //   pattern: /^[0-9]*$/, // Quy tắc để chỉ cho phép nhập số
        //   message: "Chỉ cho phép nhập số",
        // },
        {
          max: 500,
          message: "Mô tả không vượt quá 500 chữ",
        },
      ],
      allowClear: true,
      labelCol: { xs: 8, sm: 8, md: 8, lg: 24, xl: 24 },
      wrapperCol: { xs: 16, sm: 16, md: 24, lg: 24, xl: 24 },
      style: { height: "180px" },
      css: { xs: 24, sm: 24, md: 24, lg: 24, xl: 24 },
    },
  ];
  const dataPTKM = [
    {
      type: SELECT,
      name: "type",
      options: [
        { value: 1, label: "Chiết khấu theo giá trị thanh toán" },
        { value: 2, label: "Chiết khấu theo dịch vụ" },
        { value: 3, label: "Ưu đãi dịch vụ theo tổng giá trị thanh toán" },
      ],
      labelCol: { xs: 8, sm: 8, md: 8, lg: 24, xl: 24 },
      wrapperCol: { xs: 16, sm: 16, md: 24, lg: 24, xl: 24 },
      css: { xs: 24, sm: 24, md: 24, lg: 24, xl: 24 },
      onChange: (value: any) => {
        setSelectedOption(value);
      },
    },
  ];
  let status = useAppSelector((state) => state.employeesReducer.status);
  const dispatch = useAppDispatch();
  const activeTabKey = useAppSelector((state) => state.common.activeTab);
  const [listButton, setListButton] = useState<any[]>([]);
  let id = useAppSelector((state) => state.employeesReducer.idKM);
  let types = useAppSelector((state) => state.employeesReducer.cckmMode);
  const [dataSourceService, setDataSourceService] = useState([]);
  const [dataSourceThird, setDataSourceThird] = useState([]);
  const [dataSource, setDataSource] = useState([]);
  const [count, setCount] = useState(1);
  const [selectedOption, setSelectedOption] = useState(1);
  const [optionsData, setOptionData] = useState(dataPTKM);
  const [fieldsTTC, setFieldsTTC] = useState(dataTTC);
  const [fieldsTTAP, setFieldsTTAP] = useState(dataTTAP);
  useEffect(() => {
    getListNguonBN();
    fetchObjects();
    ColumnsService();
    getListGoiDichVu();
    getListLoaiKCB();
  }, []);
  useEffect(() => {
    // console.log(employeesStore);

    form.setFieldsValue({
      ...employeesStore,
      //isKhongGioiHan: employeesStore?.isKhongGioiHan ? 1 : 0,
      createdDate: employeesStore?.createdDate
        ? dayjs(employeesStore?.createdDate)
        : null,
      ngayBatDau: employeesStore?.ngayBatDau
        ? dayjs(employeesStore?.ngayBatDau)
        : null,
      ngayKetThuc: employeesStore?.ngayKetThuc
        ? dayjs(employeesStore?.ngayKetThuc)
        : null,
    });
  }, [employeesStore]);
  const getDetailsKM = async (id) => {
    if (id !== undefined || id !== null) {
      setLoading(true);
      try {
        let keyCounter = 1;
        const res = await discountsService.detailKM(id);
        dispatch(setKM(res));
        // form.setFieldsValue(res);
        //console.log("res",res);
        setDataSourceService(
          res?.dichVuUuDais.map((item) => {
            return {
              ...item,
              key: keyCounter++,
            };
          })
        );
        setSelectedOption(res?.type);
        setDataSourceThird(
          res?.dichVuUuDais.map((item) => {
            return {
              ...item,
              key: keyCounter++,
            };
          })
        );
        setDataSource(
          res?.dichVuUuDais.map((item) => {
            return {
              ...item,
              key: keyCounter++,
            };
          })
        );
        setLoading(false);
      } catch (error) {
        setLoading(false);
        Notification("error", "Đã xảy ra lỗi khi lấy dữ liệu");
      }
    } else {
      if (status == true) {
        setLoading(false);
        form.resetFields();
      } else {
        Notification(
          "warning",
          "Tìm kiếm và chọn danh sách ưu đãi để xem chi tiết thông tin"
        );
        setLoading(true);
      }
    }
  };
  const newDataaaaaaa = {
    key: 0,
  };
  useEffect(() => {
    if (types === "create") {
      setIsEditing(true);
      form.resetFields();
      setDataSource([newDataaaaaaa]);
      setDataSourceThird([newDataaaaaaa]);
      setDataSourceService([newDataaaaaaa]);
      form.setFieldValue("isKhongGioiHan", true);
      if (form.getFieldValue("isKhongGioiHan") === true) {
        const updatedFieldsCV = fieldsTTC.map((field) => {
          if (
            field.name === "soLanApDung" ||
            field.name === "soLuotApDungConLai"
          ) {
            return {
              ...field,
              disable: true,
            };
          } else {
            return {
              ...field,
              disable: false,
            };
          }
        });
        setFieldsTTC(updatedFieldsCV);
      } else {
        const updatedFieldsCV = fieldsTTC.map((field) => {
          if (field.name === "soLuotApDungConLai") {
            return {
              ...field,
              disable: true,
            };
          } else {
            return {
              ...field,
              disable: false,
            };
          }
        });
        setFieldsTTC(updatedFieldsCV);
      }
    } else {
      if (types === "edit") {
        getDetailsKM(id);
        setIsEditing(true);
        if (employeesStore?.isKhongGioiHan === true) {
          const updatedFieldsCV = fieldsTTC.map((field) => {
            if (
              field.name === "soLanApDung" ||
              field.name === "soLuotApDungConLai"
            ) {
              return {
                ...field,
                disable: true,
              };
            } else {
              return {
                ...field,
                disable: false,
              };
            }
          });
          setFieldsTTC(updatedFieldsCV);
        } else {
          const updatedFieldsCV = fieldsTTC.map((field) => {
            if (field.name === "soLuotApDungConLai") {
              return {
                ...field,
                disable: true,
              };
            } else {
              return {
                ...field,
                disable: false,
              };
            }
          });
          setFieldsTTC(updatedFieldsCV);
        }
      }
      if (types === "view") {
        getDetailsKM(id);
        setIsEditing(false);
        if (employeesStore?.isKhongGioiHan === true) {
          const updatedFieldsCV = fieldsTTC.map((field) => {
            if (
              field.name === "soLanApDung" ||
              field.name === "soLuotApDungConLai"
            ) {
              return {
                ...field,
                disable: true,
              };
            } else {
              return {
                ...field,
                disable: false,
              };
            }
          });
          setFieldsTTC(updatedFieldsCV);
        } else {
          const updatedFieldsCV = fieldsTTC.map((field) => {
            if (field.name === "soLuotApDungConLai") {
              return {
                ...field,
                disable: true,
              };
            } else {
              return {
                ...field,
                disable: false,
              };
            }
          });
          setFieldsTTC(updatedFieldsCV);
        }
      }
    }
    if (
      (id === null && types !== "create") ||
      (id === undefined && types !== "create")
    ) {
      dispatch(setActiveKey(tabKeys.CARD_AND_OFFER.DISCOUNTS));
    } else {
      dispatch(setActiveKey(tabKeys.CARD_AND_OFFER.DISCOUNTSADD));
    }
    form.setFieldValue("type", 1);
  }, [types, id, tabKeys, employeesStore?.isKhongGioiHan]);
  useEffect(() => {
    const disabledDateStart: RangePickerProps["disabledDate"] = (
      currentDate
    ) => {
      const endDay = form.getFieldValue("ngayKetThuc");
      if (endDay) {
        return currentDate > endDay;
      }
    };
    const disabledDateEnd: RangePickerProps["disabledDate"] = (currentDate) => {
      const start = form.getFieldValue("ngayBatDau");
      if (start) {
        return currentDate < start;
      }
    };
    dataTTAP.find((e) => e.name == "ngayBatDau").disabledDate =
      disabledDateStart;
    dataTTAP.find((e) => e.name == "ngayKetThuc").disabledDate =
      disabledDateEnd;
    setFieldsTTAP([...dataTTAP]);
  }, []);
  // const showConfirm = () => {
  //   Modal.confirm({
  //     title: "Xác nhận",
  //     content: "Bạn có muốn thoát mà không lưu thay đổi?",
  //     okText: "Xác nhận",
  //     cancelText: "Hủy",
  //     onOk: () => {
  //       console.log("ấdasdasa",dispatch(setActiveKey(tabKeys.CARD_AND_OFFER.DISCOUNTS)));

  //     },
  //   });
  // };
  //   const handleCheckIsSaveChanged = async () => {
  //     if (!employeesStore) return false;
  //     if (
  //       JSON.stringify(employeesStore)!== JSON.stringify(form.getFieldsValue())
  //     ) {
  //       return true;
  //     }
  //     return false;

  //   };
  //   const handleCheckIsTabkey = async () => {
  //     if (!employeesStore) return false;
  //     if (
  //       JSON.stringify(employeesStore)!== JSON.stringify(form.getFieldsValue()) &&
  //       JSON.stringify(tabKeys.CARD_AND_OFFER.DISCOUNTSADD)!== JSON.stringify(tabKeys.CARD_AND_OFFER.DISCOUNTSADD)
  //     ) {
  //       dispatch(setActiveKey(tabKeys.CARD_AND_OFFER.DISCOUNTSADD));
  //       return true;
  //     }
  //     return false;

  //   };
  //   const tabKeyssss = useAppSelector((el) => el.common.activeTab);
  //   console.log(tabKeyssss);
  //   useEffect(() => {
  //   //   if (!employeesStore) return;
  //   //   const handleBeforeUnload = async (event: BeforeUnloadEvent) => {
  //   //     const isUnsafeTabClose = await handleCheckIsSaveChanged();
  //   //     if (isUnsafeTabClose) {
  //   //       event.preventDefault();
  //   //       return (event.returnValue = "Bạn có muốn rời khỏi trang này không?");
  //   //     }
  //   //   };
  //   //   window.addEventListener("beforeunload", handleBeforeUnload);
  //   //   window.addEventListener("popstate", handleBeforeUnload);
  //   //  // window.addEventListener("tabKeys", handleBeforeUnload);
  //   //   return () => {
  //   //     window.removeEventListener("beforeunload", handleBeforeUnload);
  //   //     window.removeEventListener("popstate", handleBeforeUnload);
  //   //   };
  //   const isUnsafeTabCloseTab = handleCheckIsTabkey();
  //  // console.log(isUnsafeTabCloseTab);
  //   if(tabKeyssss === tabKeys.CARD_AND_OFFER.DISCOUNTSADD)
  //     {
  //       return;
  //     }
  //     else
  //     {
  //       if(isUnsafeTabCloseTab)
  //         {
  //           showConfirm();
  //         //  dispatch(setActiveKey(tabKeys.CARD_AND_OFFER.DISCOUNTS));
  //           return;
  //         }
  //     }
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  //   }, [tabKeyssss]);
  const getListLoaiKCB = async () => {
    try {
      const res = await catalogService.getListLoaiKCB();
      fieldsTTAP.find((e) => e.name == "loaiKCBList").options = await res.map(
        (e) => {
          return { value: e.id, label: e.tenLoaiKCB };
        }
      );
      setFieldsTTAP([...fieldsTTAP]);
    } catch (error) {
      // Notification("error", "Đã có lỗi khi lấy danh sách loại khám chữa bệnh");
      // fields[8].options = [];
    }
  };
  const getListNguonBN = async () => {
    try {
      const response = await medicalExaminationService.getSourcePatient();
      //console.log("Nguồn", response.data);
      fieldsTTAP.find((e) => e.name == "nguonBenhNhanList").options =
        response.data.map((e) => {
          return { value: e.id, label: e.tenNguonBenhNhan };
        });
      setFieldsTTAP([...fieldsTTAP]);
    } catch (error) {
      Notification(
        "error",
        "Lỗi xảy ra khi lấy thông tin danh mục nguồn bênh nhân"
      );
    }
  };
  const fetchObjects = async () => {
    try {
      const response = await medicalExaminationService.getListObjects();
      //  console.log(response.data);

      fieldsTTAP.find((e) => e.name == "doiTuongList").options =
        response.data.map((e) => {
          return { value: e.id, label: e.tenDoiTuong };
        });
      setFieldsTTAP([...fieldsTTAP]);
    } catch (err) {
      Notification("error", "Lỗi xảy ra khi lấy danh mục đối tượng");
    }
  };
  const handleAdd = () => {
    const newData = {
      key: count,
    };
    if (selectedOption === 1) {
      setDataSource([...dataSource, newData]);
    } else if (selectedOption === 2) {
      setDataSourceService([...dataSourceService, { ...newData }]);
    } else if (selectedOption === 3) {
      setDataSourceThird([...dataSourceThird, newData]);
    }
    setCount(count + 1);
  };
  const handleDelete = (key) => {
    if (selectedOption === 1) {
      setDataSource(dataSource.filter((item) => item.key !== key));
    } else if (selectedOption === 2) {
      setDataSourceService(
        dataSourceService.filter((item) => item.key !== key)
      );
    } else if (selectedOption === 3) {
      setDataSourceThird(dataSourceThird.filter((item) => item.key !== key));
    }
  };
  // useEffect(() => {
  //   if (
  //     dataSourceService?.map((e) => e?.giamGiaToiDa) <
  //       dataSource?.map((e) => e?.dieuKien) ===
  //     true
  //   ) {
  //     console.log("ấdasd",dataSourceService?.map((e) => e?.giamGiaToiDa) >
  //     dataSource?.map((e) => e?.dieuKien) ===
  //   true);

  //     Notification(
  //       "error",
  //       "Mức giảm tối đa không được vượt quá Tổng giá trị."
  //     );
  //     return; // Prevent further updates if validation fails
  //   }else
  //   {
  //     return;
  //   }
  // }, [dataSourceService, dataSource]);
  const handleInputChange = (key, field, value) => {
    if (selectedOption === 1) {
      const newData = [...dataSource];
      const index = newData.findIndex((item) => key === item.key);
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, { ...item, [field]: value });
        if (field === "giamGiaToiDa" && value > item.dieuKien) {
          Notification(
            "error",
            "Mức giảm tối đa không được vượt quá Tổng giá trị."
          );
          return; // Prevent further updates if validation fails
        }
        
        setDataSource(newData);
      }
    } else if (selectedOption === 2) {
      const newData = [...dataSourceService];
      const index = newData.findIndex((item) => key === item.key);
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, { ...item, [field]: value });
        setDataSourceService(newData);
      }
      // if (
      //   field === "giamGiaToiDa" && value >
      //     dataSource?.map((e) => e?.dieuKien)
      // ) {
      //   Notification(
      //     "error",
      //     "Mức giảm tối đa không được vượt quá Tổng giá trị."
      //   );
      //   return; // Prevent further updates if validation fails
      // }
    } else if (selectedOption === 3) {
      const newData = [...dataSourceThird];
      const index = newData.findIndex((item) => key === item.key);
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, { ...item, [field]: value });
        setDataSourceThird(newData);
      }
    }
  };
  const handleDiscountTypeChange = (key, value) => {
    if (selectedOption === 1) {
      const newData = [...dataSource];
      const index = newData.findIndex((item) => key === item.key);
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, { ...item, loaiGiamGia: value });
        setDataSource(newData);
      }
    } else if (selectedOption === 2) {
      const newData = [...dataSourceService];
      const index = newData.findIndex((item) => key === item.key);
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, { ...item, loaiGiamGia: value });
        setDataSourceService(newData);
      }
    } else if (selectedOption === 3) {
      const newData = [...dataSourceThird];
      const index = newData.findIndex((item) => key === item.key);
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, { ...item, loaiGiamGia: value });
        setDataSourceThird(newData);
      }
    }
  };
  //  console.log(dataSource);

  const columnsValue = [
    {
      title: "Tổng giá trị",
      dataIndex: "dieuKien",
      rules: [{ max: 10, message: "Không được nhập quá 10 số" }],
      render: (text, record) => (
        <InputNumber
          value={text}
          onChange={(value) => handleInputChange(record.key, "dieuKien", value)}
          style={{ width: "100%" }}
          formatter={formatToCurrencyType}
          parser={(value) => value.replace(/\D/g, "")}
        />
      ),
    },
    {
      title: "Chiết khấu",
      dataIndex: "giamGia",
      render: (text, record) => (
        <Row gutter={8}>
          <Col flex="auto">
            <InputNumber
              value={record.loaiGiamGia === 0 ? text : text}
              onChange={(value) =>
                handleInputChange(record.key, "giamGia", value)
              }
              style={{ width: "100%" }}
              formatter={
                record.loaiGiamGia === 0 ? formatToCurrencyType : undefined
              }
              parser={
                record.loaiGiamGia === 0
                  ? (value) => value.replace(/\D/g, "")
                  : undefined
              }
              min={record.loaiGiamGia === 1 ? 0 : undefined}
              max={record.loaiGiamGia === 1 ? 100 : undefined}
            />
          </Col>
          <Col>
            <Button
              type={record.loaiGiamGia === 1 ? "primary" : "default"}
              onClick={() => handleDiscountTypeChange(record.key, 1)}
              className="buttonphantram"
            >
              %
            </Button>
          </Col>
          <Col>
            <Button
              type={record.loaiGiamGia === 0 ? "primary" : "default"}
              onClick={() => handleDiscountTypeChange(record.key, 0)}
              className="buttonphantram"
            >
              đ
            </Button>
          </Col>
        </Row>
      ),
    },
    {
      title: "Mức giảm tối đa",
      dataIndex: "giamGiaToiDa",
      render: (text, record) => {
        const isDisabled = record.loaiGiamGia === 0;
        const value = isDisabled ? 0 : text;
    
        return (
          <InputNumber
            value={value}
            onChange={(value) =>
              handleInputChange(record.key, "giamGiaToiDa", value)
            }
            style={{ width: "100%" }}
            formatter={formatToCurrencyType}
            parser={(value) => value.replace(/\D/g, "")}
            disabled={isDisabled}
          />
        );
      },
    },
    {
      title: "Hành động",
      dataIndex: "action",
      render: (_, record) =>
        dataSource.length >= 1 ? (
          <Button
            type="text"
            icon={<RecycleIconSVG />}
            onClick={() => handleDelete(record.key)}
          />
        ) : null,
    },
  ];
  const columnsThird = [
    {
      title: "Tổng giá trị",
      dataIndex: "dieuKien",
      render: (text, record) => (
        <InputNumber
          value={text}
          onChange={(value) => handleInputChange(record.key, "dieuKien", value)}
          style={{ width: "100%" }}
          formatter={formatToCurrencyType}
          parser={(value) => value.replace(/\D/g, "")}
        />
      ),
    },
    {
      title: "Gói dịch vụ ưu đãi",
      dataIndex: "goiDichVuList",
      render: (text, record) => (
        <Select
          mode="multiple"
          value={text}
          onChange={(value) =>
            handleInputChange(record.key, "goiDichVuList", value)
          }
          style={{ width: "100%" }}
          placeholder="Tìm kiếm gói dịch vụ"
          options={goiDichVu}
          showSearch
          filterOption={(input, option) =>
            (option?.label?.toString().toLowerCase() ?? "").includes(
              input.toLowerCase()
            )
          }
        ></Select>
      ),
      width: "30%",
    },
    {
      title: "Dịch vụ ưu đãi",
      dataIndex: "dichVuList",
      render: (text, record) => (
        <Select
          mode="multiple"
          value={text}
          onChange={(value) =>
            handleInputChange(record.key, "dichVuList", value)
          }
          style={{ width: "100%" }}
          placeholder="Tìm kiếm theo tên dịch vụ"
          options={serviceOptions}
          showSearch
          filterOption={(input, option) =>
            (option?.label?.toString().toLowerCase() ?? "").includes(
              input.toLowerCase()
            )
          }
        ></Select>
      ),
      width: "30%",
    },
    {
      title: "Số lượng tối đa",
      dataIndex: "soLanApDung",
      render: (text, record) => (
        <InputNumber
          value={text}
          onChange={(value) =>
            handleInputChange(record.key, "soLanApDung", value)
          }
          style={{ width: "100%" }}
          formatter={formatToCurrencyType}
          parser={(value) => value.replace(/\D/g, "")}
        />
      ),
    },
    {
      title: "Hành động",
      dataIndex: "action",
      render: (_, record) =>
        dataSourceThird.length >= 1 ? (
          <Button
            type="text"
            icon={<RecycleIconSVG />}
            onClick={() => handleDelete(record.key)}
          />
        ) : null,
    },
  ];
  const [serviceOptions, setServiceOptions] = useState([]);
  const [goiDichVu, setGoiDichVu] = useState([]);
  const getListGoiDichVu = async () => {
    try {
      const paramss = { page: 1, limit: 1000 };
      const response = await servicePackage.getListServicePackage(paramss);
      // console.log(response);
      const optionss = response.data.map((e) => {
        return { value: e.id, label: e.tenGoiDichVu };
      });
      setGoiDichVu(optionss);
    } catch (err) {
      Notification("error", "Lỗi xảy ra khi lấy danh mục gói dịch vụ");
    }
  };
  const ColumnsService = async () => {
    try {
      const paramss = { page: 1, limit: 1000 };
      const response = await technicalService.searchListTechnicalService(
        paramss
      );
      const options = response.map((e) => {
        return { value: e.id, label: e.tenDichVu };
      });
      setServiceOptions(options);
    } catch (err) {
      Notification("error", "Lỗi xảy ra khi lấy danh mục đối tượng");
    }
  };
  const columnsService = [
    {
      title: "Dịch vụ",
      dataIndex: "dichVuList",
      render: (text, record) => (
        <Select
          value={text}
          onChange={(value) =>
            handleInputChange(record.key, "dichVuList", value)
          }
          style={{ width: "100%" }}
          mode="multiple"
          options={serviceOptions}
          showSearch
          filterOption={(input, option) =>
            (option?.label?.toString().toLowerCase() ?? "").includes(
              input.toLowerCase()
            )
          }
        ></Select>
      ),
      width: "30%",
    },
    {
      title: "Chiết khấu",
      dataIndex: "giamGia",
      render: (text, record) => (
        <Row gutter={8}>
          <Col flex="auto">
            <InputNumber
              value={record.loaiGiamGia === 0 ? text : text}
              onChange={(value) =>
                handleInputChange(record.key, "giamGia", value)
              }
              style={{ width: "100%" }}
              formatter={
                record.loaiGiamGia === 0 ? formatToCurrencyType : undefined
              }
              parser={
                record.loaiGiamGia === 0
                  ? (value) => value.replace(/\D/g, "")
                  : undefined
              }
              min={record.loaiGiamGia === 1 ? 0 : undefined}
              max={record.loaiGiamGia === 1 ? 100 : undefined}
            />
          </Col>
          <Col>
            <Button
              type={record.loaiGiamGia === 1 ? "primary" : "default"}
              onClick={() => handleDiscountTypeChange(record.key, 1)}
              className="buttonphantram"
            >
              %
            </Button>
          </Col>
          <Col>
            <Button
              type={record.loaiGiamGia === 0 ? "primary" : "default"}
              onClick={() => handleDiscountTypeChange(record.key, 0)}
              className="buttonphantram"
            >
              đ
            </Button>
          </Col>
        </Row>
      ),
    },
    // {
    //   title: "Mức giảm tối đa",
    //   dataIndex: "giamGiaToiDa",
    //   render: (text, record) => {
    //     const isDisabled = record.loaiGiamGia === 0;
    //     const value = isDisabled ? 0 : text;
    
    //     return (
    //       <InputNumber
    //         value={value}
    //         onChange={(value) =>
    //           handleInputChange(record.key, "giamGiaToiDa", value)
    //         }
    //         style={{ width: "100%" }}
    //         formatter={formatToCurrencyType}
    //         parser={(value) => value.replace(/\D/g, "")}
    //         disabled={isDisabled}
    //       />
    //     );
    //   },
    // },
    {
      title: "Hành động",
      dataIndex: "action",
      render: (_, record) =>
        dataSourceService.length >= 1 ? (
          <Button
            type="text"
            icon={<RecycleIconSVG />}
            onClick={() => handleDelete(record.key)}
          />
        ) : null,
    },
  ];
  const username = localStorage.getItem("username");
  const handleSaveKichHoat = async () => {
    //setLoading(true);
    await form.validateFields([
      "ngayKetThuc",
      "ngayBatDau",
      "tenChuongTrinh",
      "maChuongTrinh",
      // "soLanApDung",
    ]);
    const value = form.getFieldsValue();
    //console.log(value);

    let dichVuUuDais;
    switch (value.type) {
      case 1:
        dichVuUuDais = dataSource;
        break;
      case 2:
        dichVuUuDais = dataSourceService;
        break;
      case 3:
        dichVuUuDais = dataSourceThird;
        break;
      default:
        dichVuUuDais = null; // Or handle the default case as needed
    }
    // let isKhongGioiHan = Array.isArray(value.isKhongGioiHan) && value.isKhongGioiHan.includes(1);
    let ngayBatDau = new Date(value.ngayBatDau);
    ngayBatDau.setHours(0, 0, 0, 0);

    // Set ngayKetThuc time to 23:59
    let ngayKetThuc = new Date(value.ngayKetThuc);
    ngayKetThuc.setHours(23, 59, 59, 999);
    try {
      if (types === "edit" || types === "view") {
        const newValue = {
          ...value,
          tenChuongTrinh: value.tenChuongTrinh.trim(),
          maChuongTrinh: value.maChuongTrinh.trim(),
          moTa: value?.moTa?.trim(),
          id: id,
          dichVuUuDais,
          //  isKhongGioiHan,
          ngayBatDau: ngayBatDau.toISOString().replace("Z", ""),
          ngayKetThuc: ngayKetThuc.toISOString().replace("Z", ""),
          isKichHoat: true,
          nguoiTao: username,
        };
        const res = await discountsService.updateKM(id, newValue);
        Notification("success", "Lưu thành công");
        setLoading(false);
        dispatch(setActiveKey(tabKeys.CARD_AND_OFFER.DISCOUNTS));
        // form.resetFields();
      } else {
        const newValue = {
          ...value,
          tenChuongTrinh: value.tenChuongTrinh.trim(),
          maChuongTrinh: value.maChuongTrinh.trim(),
          moTa: value?.moTa?.trim(),
          //  id:id,
          dichVuUuDais,
          // isKhongGioiHan,
          ngayBatDau: ngayBatDau.toISOString().replace("Z", ""),
          ngayKetThuc: ngayKetThuc.toISOString().replace("Z", ""),
          isKichHoat: true,
          nguoiTao: username,
        };
        const res = await discountsService.createKM(newValue);
        Notification("success", "Thêm mới thành công");
        setLoading(false);
        dispatch(setActiveKey(tabKeys.CARD_AND_OFFER.DISCOUNTS));
        form.resetFields();
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error.response.status === 400) {
        Notification("error", error.response.data.message);
      } else {
        Notification("error", error.message);
      }
    }
  };
  const handleSave = async () => {
    //setLoading(true);
    await form.validateFields([
      "ngayKetThuc",
      "ngayBatDau",
      "tenChuongTrinh",
      "maChuongTrinh",
      // "soLanApDung",
    ]);
    const value = form.getFieldsValue();
    let dichVuUuDais;
    switch (value.type) {
      case 1:
        dichVuUuDais = dataSource;
        break;
      case 2:
        dichVuUuDais = dataSourceService;
        break;
      case 3:
        dichVuUuDais = dataSourceThird;
        break;
      default:
        dichVuUuDais = null; // Or handle the default case as needed
    }
    // let isKhongGioiHan = Array.isArray(value.isKhongGioiHan) && value.isKhongGioiHan.includes(1);
    let ngayBatDau = new Date(value.ngayBatDau);
    ngayBatDau.setHours(0, 0, 0, 0);

    // Set ngayKetThuc time to 23:59
    let ngayKetThuc = new Date(value.ngayKetThuc);
    ngayKetThuc.setHours(23, 59, 59, 999);
    try {
      if (types === "edit" || types === "view") {
        const newValue = {
          ...value,
          tenChuongTrinh: value.tenChuongTrinh.trim(),
          maChuongTrinh: value.maChuongTrinh.trim(),
          moTa: value?.moTa?.trim(),
          id: id,
          dichVuUuDais,
          //  isKhongGioiHan,
          ngayBatDau: ngayBatDau.toISOString().replace("Z", ""),
          ngayKetThuc: ngayKetThuc.toISOString().replace("Z", ""),
          isKichHoat: false,
          nguoiTao: username,
        };
        const res = await discountsService.updateKM(id, newValue);
        //  console.log(res);
        Notification("success", "Lưu thành công");
        setLoading(false);
        dispatch(setActiveKey(tabKeys.CARD_AND_OFFER.DISCOUNTS));
        //form.resetFields();
      } else {
        const newValue = {
          ...value,
          //  id:id,
          tenChuongTrinh: value.tenChuongTrinh.trim(),
          maChuongTrinh: value.maChuongTrinh.trim(),
          moTa: value?.moTa?.trim(),
          dichVuUuDais,
          // isKhongGioiHan,
          ngayBatDau: ngayBatDau.toISOString().replace("Z", ""),
          ngayKetThuc: ngayKetThuc.toISOString().replace("Z", ""),
          isKichHoat: false,
          nguoiTao: username,
        };
        const res = await discountsService.createKM(newValue);
        Notification("success", "Thêm mới thành công");
        setLoading(false);
        dispatch(setActiveKey(tabKeys.CARD_AND_OFFER.DISCOUNTS));
        form.resetFields();
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error.response.status === 400) {
        Notification("error", error.response.data.message);
      } else {
        Notification("error", error.message);
      }
    }
  };
  const handleEdit = () => {
    setIsEditing(true);
  };
  const handleSaveHuyKichHoat = async () => {
    //setLoading(true);
    await form.validateFields([
      "ngayKetThuc",
      "ngayBatDau",
      "tenChuongTrinh",
      "maChuongTrinh",
      //  "soLanApDung",
    ]);
    const value = form.getFieldsValue();
    try {
      if (types === "edit" || types === "view") {
        const res = await discountsService.HuyKM(id);
        Notification("success", "Hủy kích hoạt thành công");
        setLoading(false);
        dispatch(setActiveKey(tabKeys.CARD_AND_OFFER.DISCOUNTS));
      }
    } catch (error) {
      setLoading(false);
      if (error.response.status === 400) {
        Notification("error", error.response.data.message);
      } else {
        Notification("error", error.message);
      }
    }
  };
  const handleCanel = async () => {
    dispatch(setActiveKey(tabKeys.CARD_AND_OFFER.DISCOUNTS));
    // form.resetFields();
  };
  return (
    <Spin spinning={loading}>
      <Form form={form}>
        <div className="discountsAdd">
          <div className="container">
            <Space direction="vertical" style={{ width: "100%" }}>
              <Row justify={"space-between"}>
                <Col>
                  <Row style={{ marginTop: "4px" }} justify={"start"}>
                    <Typography.Text strong>
                      Tạo chương trình ưu đãi
                    </Typography.Text>
                  </Row>
                </Col>
                <Col>
                  <Row style={{ marginBottom: "4px" }} justify={"end"}>
                    {isEditing ? (
                      <>
                        <Button
                          onClick={() => {
                            handleCanel();
                          }}
                          style={{ marginRight: "5px" }}
                        >
                          Hủy
                        </Button>
                        {(types === "edit" || types === "view") && (
                          <Button
                            type="primary"
                            onClick={() => {
                              handleSaveHuyKichHoat();
                            }}
                            style={{
                              backgroundColor: "#ee0b0b",
                              marginRight: "5px",
                            }}
                          >
                            Hủy kích hoạt
                          </Button>
                        )}
                        <Button
                          type="primary"
                          onClick={() => {
                            handleSaveKichHoat();
                          }}
                          style={{
                            backgroundColor: "#0E56CF",
                            marginRight: "5px",
                          }}
                        >
                          Lưu và kích hoạt
                        </Button>
                        <Button
                          type="primary"
                          onClick={() => {
                            handleSave();
                          }}
                        >
                          Lưu
                        </Button>
                      </>
                    ) : (
                      <Button
                        className="btn-sub"
                        type="primary"
                        onClick={handleEdit}
                        icon={<Icon.edit />}
                      >
                        Chỉnh sửa
                      </Button>
                    )}
                  </Row>
                </Col>
              </Row>
            </Space>
          </div>
          <div style={{ width: "100%", display: "flex" }}>
            <div
              className="container"
              style={{ width: "69%", marginRight: "1%" }}
            >
              <Space direction="vertical" style={{ width: "100%" }}>
                <Row style={{ marginTop: "4px" }} justify={"start"}>
                  <Typography.Text strong>Thông tin chung</Typography.Text>
                </Row>
                <Row justify={"space-between"}>
                  <Col>
                    <Row gutter={[16, 8]}>
                      <InputFields data={fieldsTTC}></InputFields>
                    </Row>
                  </Col>
                </Row>
              </Space>
            </div>
            <div className="container" style={{ width: "30%" }}>
              <Space direction="vertical" style={{ width: "100%" }}>
                <Row style={{ marginTop: "4px" }} justify={"start"}>
                  <Typography.Text strong>Thông tin áp dụng</Typography.Text>
                </Row>
                <Row justify={"space-between"}>
                  <Col>
                    <Row gutter={[12, 8]}>
                      <InputFields data={fieldsTTAP}></InputFields>
                    </Row>
                  </Col>
                </Row>
              </Space>
            </div>
          </div>
          <div className="container">
            <Space direction="vertical" style={{ width: "100%" }}>
              <Row justify="space-between">
                <Col>
                  <Row style={{ marginTop: "4px" }} justify="start">
                    <Typography.Text strong>
                    Phương thức ưu đãi
                    </Typography.Text>
                  </Row>
                </Col>
              </Row>
              <Row justify="center">
                <InputFields data={optionsData} />
              </Row>
              {selectedOption === 1 && (
                <Row justify="center">
                  <Table
                    bordered
                    dataSource={dataSource}
                    columns={columnsValue}
                    pagination={false}
                    footer={() => (
                      <Button
                        onClick={handleAdd}
                        style={{ marginLeft: "-15px" }}
                      >
                        + Thêm điều kiện
                      </Button>
                    )}
                  />
                </Row>
              )}
              {selectedOption === 2 && (
                <Row justify="center">
                  <Table
                    bordered
                    dataSource={dataSourceService}
                    columns={columnsService}
                    pagination={false}
                    footer={() => (
                      <Button
                        onClick={handleAdd}
                        style={{ marginLeft: "-15px" }}
                      >
                        + Thêm điều kiện
                      </Button>
                    )}
                  />
                </Row>
              )}
              {selectedOption === 3 && (
                <Row justify="center">
                  <Table
                    bordered
                    dataSource={dataSourceThird}
                    columns={columnsThird}
                    pagination={false}
                    footer={() => (
                      <Button
                        onClick={handleAdd}
                        style={{ marginLeft: "-15px" }}
                      >
                        + Thêm điều kiện
                      </Button>
                    )}
                  />
                </Row>
              )}
            </Space>
          </div>
        </div>
      </Form>
    </Spin>
  );
};

export default DiscountsAdd;
